import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import { langConversionHelper } from "../../_helpers/langConversionHelper";
import { phoneNumberFormat } from "../../_helpers/PhoneNumberHelper";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import Cookies from "universal-cookie";
import { LifeSafer } from "../../_helpers/BrandConstants";
import PropTypes from "prop-types";

const AppointmentCard = ({ clientCheckData }) => {
  const { t, i18n } = useTranslation();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const appointmentDateString =
    clientCheckData?.clientInformation?.appointmentDate;
  let appointmentMonthNum = appointmentDateString?.substring(0, 2);
  const monthIndex = parseInt(appointmentMonthNum, 10) - 1;
  const dateData = new Date(appointmentDateString);
  const appointmentDate = dateData?.getDate()?.toString()?.padStart(2, "0");
  const formattedAppointmentTime = clientCheckData?.clientInformation?.appointmentTime?.substring(0,5);
  const phoneNumber = clientCheckData?.clientInformation?.contactUsNumber;
  const cpUrl = process.env.CP_URL;
  const englishAbbrevs = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let appointmentMonthAbbrev = englishAbbrevs[monthIndex];
  if (i18n?.language !== "en") {
    appointmentMonthAbbrev = langConversionHelper?.monthAbbrevConversion(
      appointmentMonthAbbrev,
      i18n?.language
    );
  }

  const CustomIcon = styled(InsertInvitationIcon)(() => ({
    color: "#76bc21",
    height: 90,
    width: 90,
    opacity: 0.2,
  }));

  const CustomTypo = styled(Typography)(() => ({
    textAlign: "center",
    zIndex: 10,
    fontSize: 16,
    marginTop: -84,
    fontWeight: 600,
    textShadow: "1px 3px 2px rgba(28,53,94,.4)",
  }));

  const CustomTypo2 = styled(Typography)(() => ({
    textAlign: "center",
    zIndex: 10,
    fontSize: 36,
    marginTop: -10,
    fontWeight: 600,
    textShadow: "1px 3px 2px rgba(28,53,94,.4)",
  }));

  const LabelHolder = styled(Grid)(() => ({
    textAlign: "left",
    paddingTop: 4,
  }));

  const LabelTypo = styled(Typography)(() => ({
    fontSize: 20,
    fontWeight: 600,
  }));

  const LabelTypoAlt = styled(Typography)(() => ({
    fontSize: 14,
  }));

  const ButtonUpdate = styled(Button)(() => ({
    backgroundColor: "#fff",
    color: "#00798c",
    fontWeight: 600,
  }));

  const CustomPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: "left",
    minHeight: 320,
    overflow: "auto",
    width: 320,
  }));

  return (
    <div>
      <CustomPaper elevation={2}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{ mb: 1 }}
        >
          <Grid size={11} sx={{ textAlign: "left" }}>
            <Typography variant="h6" fontWeight={800}>
              {t("steps.scheduleInstallation")}
            </Typography>
          </Grid>
          <Grid size={1} sx={{ textAlign: "left" }}>
            <Typography variant="h6" fontWeight={800}>
              <DirectionsCarIcon sx={{ color: "#1c355e", opacity: "80%" }} />
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="flex-start" mt={1}>
          <Grid size={{ xs: 4 }}>
            <CustomIcon />
            <CustomTypo>{appointmentMonthAbbrev}</CustomTypo>
            <CustomTypo2>{appointmentDate}</CustomTypo2>
          </Grid>

          <Grid size={{ xs: 1 }}>
            <Divider
              orientation="vertical"
              sx={{
                backgroundColor: "rgba(28,53,94,0.8)",
                marginTop: 1,
                marginLeft: 1,
                width: 2,
              }}
            />
          </Grid>

          <LabelHolder size={{ xs: 7 }}>
            <LabelTypo>
              {formattedAppointmentTime}
            </LabelTypo>
            <LabelTypo>
              {clientCheckData?.clientInformation?.appointmentLocation}
            </LabelTypo>

            <LabelTypoAlt>
              {clientCheckData?.clientInformation?.deviceType === "IID" || clientCheckData?.clientInformation?.deviceType === "ISA" || clientCheckData?.clientInformation?.deviceType?.toLowerCase() === "Speed"
                ? `${clientCheckData?.clientInformation.vehicleInfo}`
                : t("steps.pamShort")}
            </LabelTypoAlt>
          </LabelHolder>

          <Grid size={{ xs: 12 }} sx={{ mt: 2, ml: 2, textAlign: "left" }}>
            <Typography variant="body1">
              {t("steps.appointmentMessage")}
            </Typography>
          </Grid>

          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
            mt={2}
          >
            <Grid>
              <Button
                href={cpUrl}
                variant="contained"
                component="a"
                color="primary"
                size="medium"
              >
                {t("steps.myAccount")}
              </Button>
            </Grid>
            <Grid>
              <ButtonUpdate
                variant="contained"
                size="medium"
                component="a"
                href={`tel:${
                  phoneNumber
                    ? phoneNumber
                    : t(`brandInfo.brandPhone.${brand}`).replace(/\D/g, "")
                }`}
              >
                {phoneNumberFormat(
                  phoneNumber ? phoneNumber : t(`brandInfo.brandPhone.${brand}`)
                )}
              </ButtonUpdate>
            </Grid>
          </Grid>
        </Grid>
      </CustomPaper>
    </div>
  );
};

AppointmentCard.propTypes = {
  clientCheckData: PropTypes.object,
};

export default AppointmentCard;
